import {
  addDays,
  differenceInMonths,
  format,
  parse,
  startOfMonth,
} from 'date-fns';

import simpleFormatDateDifference from './simpleFormatDateDifference';

export default function simpleFormattedDateToDiff(formattedDate: string, dateFormat: string) {
  const formattedDateRelevantSlice = formattedDate.slice(0, dateFormat.length);

  const date = parse(formattedDateRelevantSlice, dateFormat, new Date());
  const isMonthFormat = format(addDays(date, 1), dateFormat) === formattedDateRelevantSlice;

  if (isMonthFormat) {
    const currentDate = startOfMonth(new Date());
    const monthDiff = differenceInMonths(date, currentDate);

    if (dateFormat === 'yyyy') {
      return `m-${Math.abs(monthDiff)}`;
    }

    return monthDiff < 0 ? `m${monthDiff}` : `m+${monthDiff}`;
  }

  return simpleFormatDateDifference(date) as string;
}
